import { createVNode as o, mergeProps as l } from "vue";
import a from "../node_modules/@pf-ui/pf-icon-svg/es/asn/MessageFilled.js";
import i from "../components/PfIcon.js";
const e = (r, s) => {
  const t = {
    ...r,
    ...s.attrs
  };
  return o(i, l(t, {
    icon: a
  }), null);
};
e.displayName = "MessageFilled";
e.inheritAttrs = !1;
export {
  e as default
};
